import styled from "styled-components";
import { media, theme } from "../../theme/theme";
import { V3Caption } from "../Typography";

export const SOCIAL_BAR_BR = 1050;

export const SRDWrapper = styled.div`
    margin: 0 auto;
    position: fixed;
    bottom: 0;
    background: white;
    width: 100%;
    padding: 22px;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1), 0px 8px 20px rgba(0, 0, 0, 0.2);
    width:  100%;
    z-index: 2;

    ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
        width: 199%;
    }

    ${media.custom(SOCIAL_BAR_BR)} {
        max-width: 900px;
        height: 0;
        position: sticky;
        display: flex;
        top: 114px;
        justify-content: flex-end;
        bottom: initial;
        background: transparent;
        padding: 0;
        width: auto;
        box-shadow: none;
        z-index: 0;
    }

    @media print {
        display: none;
    }
`;

export const SRDContent = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    
    ${media.custom(SOCIAL_BAR_BR)} {
        width: auto;
        flex-direction: column;
        max-width: 90px;
        align-items: flex-start;
    }

    > p {
        margin-left: auto;

        ${media.custom(SOCIAL_BAR_BR)} {
            margin-left: initial;
        }

        &:first-child {
            order: 4;
            align-self: flex-end;

            ${media.custom(SOCIAL_BAR_BR)} {
                order: initial;
            }
        }
    }
`;

export const SRDCaptionWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-right: 25px;

    ${media.custom(SOCIAL_BAR_BR)} {
        margin-right: 0;
    }

    > div {
        display: inline-flex;

        &:first-child {
            margin-right: 8px;
        }
    }
`;

export const SCRCountElem = styled.div`
    display: flex;
    align-items: center;
    margin-right: 34px;

    ${media.custom(SOCIAL_BAR_BR)} {
        margin-top: 14px;
        margin-right: initial;
    }

    > div {
        &:first-child {
            display: inline-flex;
            margin-right: 12px;
        }
    }
`;

export const ReportMobileContent = styled.div`
    max-width: 280px;
    margin: 0 auto;
    padding: 12px 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    >div {
        &:first-child {
            width: 16px;
            height: 16px;
            flex-shrink: 0;
            margin-right: 16px;
            display: inline-flex;
        }

        &:nth-child(3) {
            margin-left: auto;
        }
    }
`;

export const ReportSeparator = styled.hr`
    border: ${({ theme }) => theme ? `1px solid ${theme.v3.colors.grey88}` : null};
    max-width: 370px;
    margin: 7px auto;
`

export const SharesReportCaption = styled(V3Caption)`
    color: white;
`;